<h2>Content Inventory</h2>

<!-- Show available datasets for debugging -->
<div *ngIf="!urls.length" class="debug-info">
  <p><strong>No URLs found.</strong></p>
  <p>Available datasets: {{ availableDatasets.join(', ') || 'None' }}</p>
  <p>Please upload GSC data with a "pages" dataset to see URLs.</p>
</div>

<!-- Show URLs when available -->
<div *ngIf="urls.length > 0">
  <p>Found {{ urls.length }} URLs:</p>
  <ul>
    <li *ngFor="let row of urls">
      <ng-container *ngIf="row.page && row.page.length > 0; else missingUrl">
        <a (click)="goToUrlDetail(row.page)">{{ row.page }}</a>
        <span class="url-stats">
          ({{ row.clicks }} clicks, {{ row.impressions }} impressions)
        </span>
      </ng-container>
      <ng-template #missingUrl>
        <span class="missing-url">[No URL found]</span>
        <span class="url-stats">
          ({{ row.clicks }} clicks, {{ row.impressions }} impressions)
        </span>
        <pre class="debug-json">{{ row | json }}</pre>
      </ng-template>
    </li>
  </ul>
</div>

<!-- TODO: Add more columns and filters as needed --> 